import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      width: '50vw',
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 2.5),
    },
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    position: 'absolute',
    left: '50%',
    top: '45%',
    transform: 'translate(-50%, -50%)',
    opacity: 0,

    '& img': {
      width: '100%',
    },
  },

  fadeIn: {
    opacity: 1,
    transition: 'opacity 1.5s',
  },
}));
